'use client'

import Image from 'next/image'
import { useRef } from 'react'
import './frosty-widget.css'

export const FROSTY_IMAGE = '/mascots/frosty.png'

interface FrostyPillProps {
  open: boolean
  onToggle: () => void
  busy?: boolean
  label?: string
  descriptionId?: string
}

/** Keep the visible launcher available before conversation code is needed. */
export function FrostyPill({ open, onToggle, busy = false, label = 'Ask Frosty', descriptionId }: FrostyPillProps) {
  // FRIDGE-1079: the idle motion is CSS now (frosty-widget.css — a head tilt every 5 s while the
  // panel is closed, prefers-reduced-motion gated). The old scroll-driven wiggle needed 450px of
  // scrolling and an 8 s cooldown and never fired on a still page.
  const avatar = useRef<HTMLSpanElement>(null)

  // FRIDGE-1562 (owner approved 10/16/2026): a round 56px launcher, Frosty's face without the words,
  // because the pill covered links, prices and text in the lower-right corner. Its accessible name
  // stays the label ("Ask Frosty") through aria-label.
  return (
    <button type="button" className="chatpill frosty-pill" onClick={onToggle} aria-expanded={open} aria-controls="fridge-chat" aria-label={label} aria-busy={busy || undefined} aria-describedby={descriptionId} disabled={busy}>
      <span ref={avatar} className="frosty-avatar"><Image src={FROSTY_IMAGE} alt="" width={48} height={48} style={{ height: 48 }} /></span>
    </button>
  )
}
